export function join() {
    var source = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        source[_i] = arguments[_i];
    }
    var output = source
        .flat()
        .filter(Boolean)
        .join(" ");
    return output ?
        output :
        null;
}
// Date functions - work with UTC Date created from given date string as 2024-12-31 by adding "T00:00:00+00:00"
export var getDayNumberFromUTCDate = function (d) {
    return d.getUTCDate();
};
export var getMonthNumberFromUTCDate = function (d) {
    return d.getUTCMonth() + 1;
};
export var getMonthNameShortFromUTCDate = function (d) {
    return getMonthNameShortByNumber(getMonthNumberFromUTCDate(d));
};
export var getMonthNameShortByNumber = function (m) {
    var date = new Date();
    date.setDate(10);
    date.setMonth(m - 1);
    return date.toLocaleString('default', { month: 'short' });
};
export var getMonthNameLongByNumber = function (m) {
    var date = new Date();
    date.setDate(10);
    date.setMonth(m - 1);
    return date.toLocaleString('default', { month: 'long' });
};
export function getIsoString(d) {
    if (isValidDate(d)) {
        var tzoffset = d.getTimezoneOffset() * 60000;
        return (new Date(d.getTime() - tzoffset)).toISOString().slice(0, -1);
    }
    return "";
}
export function getDateInstanceWithZeroUTCTimeFromDateString(d) {
    var new_date = new Date(d.slice(0, 10) + 'T00:00:00+00:00');
    return isValidDate(new_date) ? new_date : null;
}
export function getIsoStringDate(d) {
    return isValidDate(d) ? d.toISOString().slice(0, 10) : "";
}
export function getIsoStringDateTime(d) {
    if (isValidDate(d)) {
        var tzoffset = d.getTimezoneOffset() * 60000;
        return (new Date(d.getTime() - tzoffset)).toISOString().slice(0, 19);
    }
    return "";
}
export function isValidDate(d) {
    if (d) {
        if (d.toString() === 'Invalid Date') {
            return false;
        }
        return d instanceof Date;
    }
    return false;
}
export function isValidTimeString(t) {
    if (t) {
        if (t.length === 5 || t.length === 7) {
            var d = new Date('2000-01-01T' + t);
            return isValidDate(d);
        }
    }
    return false;
}
export function getDateComparison(d1, d2) {
    if (isValidDate(d1) && isValidDate(d2)) {
        if (d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()) {
            return true;
        }
    }
    return false;
}
// Date to text
export var monnths_2pad = [
    { "key": 1, "value": "ledna" },
    { "key": 2, "value": "února" },
    { "key": 3, "value": "března" },
    { "key": 4, "value": "dubna" },
    { "key": 5, "value": "května" },
    { "key": 6, "value": "června" },
    { "key": 7, "value": "července" },
    { "key": 8, "value": "srpna" },
    { "key": 9, "value": "září" },
    { "key": 10, "value": "října" },
    { "key": 11, "value": "listopadu" },
    { "key": 12, "value": "prosince" },
];
export var getMonthName2padFromNumber = function (m) {
    var month = monnths_2pad.find(function (x) { return x.key === m; });
    if (month) {
        return month.value;
    }
    return "";
};
export function getDateText_DayMonthYear(d) {
    if (isValidDate(d)) {
        return d.getDate().toString() + '. ' + (d.getMonth() + 1).toString() + '. ' + d.getFullYear();
    }
    return "";
}
export function getDateText_DayMonthNameYear(d) {
    if (isValidDate(d)) {
        return d.getDate().toString() + '. ' + getMonthName2padFromNumber(d.getMonth() + 1) + ' ' + d.getFullYear();
    }
    return "";
}
export function getDateAndTimeText_DayMonthHourMinute(d) {
    if (isValidDate(d)) {
        return d.getDate().toString() + '.' + (d.getMonth() + 1).toString() + '. ' + d.toTimeString().substring(0, 5);
    }
    return "";
}
export function getDateAndTimeText_DayMonthYearHourMinute(d) {
    if (isValidDate(d)) {
        return "".concat(d.getDate().toString(), ". ").concat(d.getMonth() + 1, ". ").concat(d.getFullYear(), " ").concat(d.toTimeString().substring(0, 5));
    }
    return "";
}
export function getTimeText_HourMinute(d) {
    if (isValidDate(d)) {
        return "".concat(d.toTimeString().substring(0, 5));
    }
    return "";
}
export function getDateTextTwoDates_DayMonthNameYear(d1, d2) {
    if (isValidDate(d1) && isValidDate(d2)) {
        var d1_day = d1.getDate();
        var d1_month = d1.getMonth() + 1;
        var d1_year = d1.getFullYear();
        var d2_day = d2.getDate();
        var d2_month = d2.getMonth() + 1;
        var d2_year = d2.getFullYear();
        if (d1_year === d2_year) {
            if (d1_month === d2_month) {
                if (d1_day === d2_day) {
                    return d1_day.toString() + '. ' + getMonthName2padFromNumber(d1_month) + ' ' + d1_year;
                }
                else {
                    return d1_day.toString() + '. - ' + d2_day.toString() + '. ' + getMonthName2padFromNumber(d1_month) + ' ' + d1_year;
                }
            }
            else {
                return d1_day.toString() + '. ' + getMonthName2padFromNumber(d1_month) + ' - ' + d2_day.toString() + '. ' + getMonthName2padFromNumber(d2_month) + ' ' + d1_year;
            }
        }
        else {
            return d1_day.toString() + '. ' + getMonthName2padFromNumber(d1_month) + ' ' + d1_year + ' - ' + d2_day.toString() + '. ' + getMonthName2padFromNumber(d2_month) + ' ' + d2_year;
        }
    }
    else if (isValidDate(d1)) {
        return d1.getDate().toString() + '. ' + getMonthName2padFromNumber(d1.getMonth() + 1) + ' ' + d1.getFullYear();
    }
    return "";
}
//
export function replaceAll(source, find, replace) {
    var val = source;
    var prev_val = "";
    while (prev_val != val && val != "") {
        prev_val = val;
        val = val.replace(find, replace);
    }
    return val;
}
export function isValidUrl(val) {
    var url;
    try {
        url = new URL(val);
        return url.protocol === "http:" || url.protocol === "https:";
    }
    catch (err) {
        return false;
    }
}
// validating bank account number
export function isValidInt(s) {
    var num = Number(s);
    return !isNaN(num) && Number.isInteger(num);
}
function checkDivisibility(val, divider) {
    return val % divider == 0;
}
export function isValidBankAccountNumber(val) {
    var part_a = '';
    var part_b = '';
    var part_c = '';
    // if (!val.includes('/')) return false;
    if (val.split('/').length != 2)
        return false;
    if (val.split('-').length > 2)
        return false;
    part_b = val.split('/')[0];
    part_c = val.split('/')[1];
    if (part_b.includes('-')) {
        part_a = part_b.split('-')[0];
        part_b = part_b.split('-')[1];
    }
    if (part_a)
        if (!isValidInt(part_a))
            return false;
    if (!isValidInt(part_b))
        return false;
    // if (!isValidInt(part_c)) return false;
    if (!checkBankCode(part_c))
        return false;
    if (part_a.length > 6)
        return false;
    if (part_b.length > 10)
        return false;
    if (part_c.length > 4)
        return false;
    var mults = [1, 2, 4, 8, 5, 10, 9, 7, 3, 6];
    var checksum_a = 0;
    var checksum_b = 0;
    var len;
    len = part_b.length;
    for (var i = 0; i < len; i++) {
        checksum_b += Number(part_b[len - 1 - i]) * mults[i];
    }
    if (part_a) {
        len = part_a.length;
        for (var i = 0; i < len; i++) {
            checksum_a += Number(part_a[len - 1 - i]) * mults[i];
        }
    }
    if (part_a)
        if (!checkDivisibility(checksum_a, 11))
            return false;
    if (!checkDivisibility(checksum_b, 11))
        return false;
    return true;
}
function checkBankCode(val) {
    var codes = [
        "0100",
        "0300",
        "0600",
        "0710",
        "0800",
        "2010",
        "2020",
        "2030",
        "2060",
        "2070",
        "2100",
        "2200",
        "2220",
        "2240",
        "2250",
        "2260",
        "2275",
        "2600",
        "2700",
        "3030",
        "3050",
        "3060",
        "3500",
        "4000",
        "4300",
        "5500",
        "5800",
        "6000",
        "6100",
        "6200",
        "6210",
        "6300",
        "6700",
        "6800",
        "7910",
        "7940",
        "7950",
        "7960",
        "7970",
        "7980",
        "7990",
        "8030",
        "8040",
        "8060",
        "8090",
        "4150",
        "8200",
        "8215",
        "8200",
        "8215",
        "8220",
        "8225",
        "8230",
        "8240",
        "8250",
        "8255",
        "8260",
        "8265",
        "8270",
        "8280",
        "8290",
        "8291",
        "8292",
        "8293",
        "8294",
        "8295",
        "8296",
        "8297",
        "8298",
    ];
    if (codes.includes(val))
        return true;
    return false;
}
